import React, { useEffect, useState } from "react";
import Sidebar from "../../component/home/sidebar";
import InputField from "../../component/input-field";
import { useSelector } from "react-redux/es/hooks/useSelector";

export default function Myaccount() {
  const [openOnboard, setOpenOnboard] = useState(false);

  const user = useSelector((state) => state.auth);

  useEffect(() => {
    setOpenOnboard(!openOnboard);
  }, []);

  // Making mobile ready
  const [width, setWidth] = useState();

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  // Creating state to hide or show the content
  const [showContent, setShowContent] = useState(false);

  const handleEyeButtonClick = () => {
    setShowContent(!showContent);
  };

  // Creating state for advance control setting.
  // const [checked, setChecked] = useState(false);

  // const handleControlChange = () => {
  //   setChecked(!checked);
  // };

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <div className="flex flex-col md:flex-row" style={{ height: 'calc(-110px + 100vh)' }}>
        <Sidebar />
        <div className="flex-auto p-5 bg-white max-h-full">
          <div className="mb-5">
            <h4 className="text-xl font-bold leading-8 mb-4">
              Company Information
            </h4>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Company
              </h4>
              <div className="w-full md:flex md:justify-end space-x-5 py-2">
                <div className="text-sm font-normal leading-6 ">
                  <InputField
                    type="text"
                    value={user.company.name}
                    label={width < 768 ? "Company Name" : null}
                    disabled
                    inputClass=" px-10"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Email
              </h4>
              <div className="w-full md:flex md:justify-end space-x-5 py-2 md:w-3/4 xl:w-1/4">
                <InputField
                  value={user.email}
                  label={width < 768 ? "Email" : null}
                  disabled
                />
              </div>
            </div>

            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Secret Key
              </h4>
              <div className="w-full md:flex md:justify-end space-x-5 py-2 md:w-3/4 xl:w-1/4">
                <InputField
                  type={showContent ? "text" : "password"}
                  value={user.company.id}
                  label={width < 768 ? "Secret Key" : null}
                  suffix={
                    !showContent ? (
                      <span
                        className="far fa-eye-slash z-10 opacity-1 cursor-pointer"
                        onClick={(e) => handleEyeButtonClick()}
                      ></span>
                    ) : (
                      <span
                        className="far fa-eye z-10 opacity-1 cursor-pointer"
                        onClick={(e) => handleEyeButtonClick()}
                      ></span>
                    )
                  }
                />
              </div>
            </div>
          </div>

          {/* <div className="flex justify-between items-center">
            <h4 className="text-xl font-bold leading-8">
              Advance Control Settings
            </h4>
            <div className="flex items-center ml-4">
              <div className="form-switch">
                <input
                  type="checkbox"
                  name="Advance Control Setting"
                  checked={checked}
                  onChange={handleControlChange}
                  id="controlSetting"
                  className="sr-only"
                />
                <label htmlFor="controlSetting" className="bg-slate-400">
                  <span
                    className="bg-white shadow-sm"
                    aria-hidden="true"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div className={`${checked ? "block" : "hidden"}`}>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Secret Key
              </h4>
              <div className="w-full md:flex md:justify-end space-x-5 py-2 md:w-3/4 xl:w-1/4">
                <InputField
                  type={showContent ? "text" : "password"}
                  value={user.company.id}
                  label={width < 768 ? "Secret Key" : null}
                  suffix={
                    !showContent ? (
                      <span
                        className="far fa-eye-slash z-10 opacity-1 cursor-pointer"
                        onClick={(e) => handleEyeButtonClick()}
                      ></span>
                    ) : (
                      <span
                        className="far fa-eye z-10 opacity-1 cursor-pointer"
                        onClick={(e) => handleEyeButtonClick()}
                      ></span>
                    )
                  }
                />
              </div>
            </div>
          </div>

          <div className={`${checked ? "block" : "hidden"}`}>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Application
              </h4>
              <div className="w-full md:flex md:justify-end space-x-5 py-2">
                <div className="text-sm font-normal leading-6">
                  <InputField
                    type="text"
                    value={user.company.application_name}
                    label={width < 768 ? "Application" : null}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={`${checked ? "block" : "hidden"}`}>
            <div className="hidden md:flex md:justify-between md:items-center mt-4">
              <h4 className="text-xs text-gray-400 font-semibold leading-6">
                API
              </h4>
              <div className="flex items-center justify-start w-1/4 px-4">
                <h4 className="text-xs text-gray-400 font-semibold leading-6">
                  URL
                </h4>
              </div>
            </div>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Department
              </h4>
              <div className="w-full md:flex md:justify-end py-3 md:w-3/4 xl:w-1/4">
                <div className="text-sm font-normal leading-6">
                  <InputField
                    type="text"
                    placeholder="Enter department url"
                    label={width < 768 ? "Department URL" : null}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Users
              </h4>
              <div className="w-full md:flex md:justify-end py-3 md:w-3/4 xl:w-1/4">
                <div className="text-sm font-normal leading-6 ">
                  <InputField
                    type="text"
                    placeholder="Enter user url"
                    label={width < 768 ? "User URL" : null}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <h4 className="text-xl font-bold leading-8 ">Asset Type</h4> */}
          {/*<div className={`${checked ? "block" : "hidden"}`}>
            <div className="flex justify-between items-center border-b border-gray-300">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                Asset URL
              </h4>
              <div className="w-full md:flex md:justify-end py-3 md:w-3/4">
                <div className="text-sm font-normal leading-6">
                  <InputField
                    type="text"
                    value={user.company?.asset_type_list}
                    placeholder="Enter asset url"
                    label={width < 768 ? "Asset URL" : null}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={`${checked ? "block" : "hidden"} py-2`}>
            <h4 className="hidden md:block text-xl font-bold leading-8 ">
              Whitelist
            </h4>

            <div className="flex justify-between items-center">
              <h4 className="hidden md:block text-sm font-medium leading-6">
                url
              </h4>
              <div className="w-full md:flex md:justify-end py-3 md:w-3/4">
                <InputField
                  type="text"
                  placeholder="Enter whitelisted url"
                  label={width < 768 ? "Whitelisted URL" : null}
                />
              </div>
            </div>
            <div className="flex justify-end spacing-x-2">
              <button
                // onClick={submit}
                type="button"
                className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
              >
                Save Changes
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

Myaccount.auth = { path: "/myaccount", role: ["super-admin"] };
